import { render, staticRenderFns } from "./TreatyModal.vue?vue&type=template&id=4a4afc2e&scoped=true&"
import script from "./TreatyModal.vue?vue&type=script&lang=js&"
export * from "./TreatyModal.vue?vue&type=script&lang=js&"
import style0 from "./TreatyModal.vue?vue&type=style&index=0&id=4a4afc2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4afc2e",
  null
  
)

export default component.exports